import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useActionCellStyles } from 'kineticUtils/styles/Tables';

const useSelectionColumnStyles = makeStyles(() => {
  const { actionCell } = useActionCellStyles();
  return createStyles({
    selectionCell: { ...actionCell, textAlign: 'left' },
  });
});

export default useSelectionColumnStyles;
